import React, { useLayoutEffect } from "react";
import { Box, Button, Typography, IconButton, Paper } from "@mui/material";
import jsonData from "./loginconfig.json";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SignIn from "../Signin";
import Copyright from "../Copyright";

const LoginPage = ({ setShowAppBar }) => {
  const navigate = useNavigate();

  useLayoutEffect(() => {
    setShowAppBar(false);
    return () => setShowAppBar(true);
  }, [setShowAppBar]);

  const handleClick = (button) => {
    if (button.text === "Create Account") navigate("/createaccountoptions");
    if (button.text === "Back") navigate("/");
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between", // Key: ensures footer stays at bottom
        px: 2,
        pt: 4,
      }}
    >
      {/* Main Content */}
      <Box>
        {/* Top Buttons */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            mb: 2,
          }}
        >
          {jsonData.layout[0].columns.map((button, index) =>
            button.text === "Back" ? (
              <IconButton key={index} onClick={() => handleClick(button)}>
                <ArrowBackIosNewIcon />
              </IconButton>
            ) : (
              <Button
                key={index}
                onClick={() => handleClick(button)}
                variant="outlined"
                disabled={button.text === "Create Account"}
              >
                {button.text}
              </Button>
            )
          )}
        </Box>

        {/* Header */}
        <Typography
          fontWeight="bold"
          variant="h5"
          color="primary"
          sx={{
            textAlign: "center",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            mb: 4,
          }}
        >
          {jsonData.layout[1].columns[0].header}
        </Typography>

        {/* Google Sign-In Box */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 4,
          }}
        >
          <Paper elevation={3} sx={{ p: 4, width: "100%", maxWidth: 400 }}>
            <SignIn />
          </Paper>
        </Box>
      </Box>

      {/* Footer */}
      <Box sx={{ textAlign: "center", py: 2 }}>
        <Copyright />
      </Box>
    </Box>
  );
};

export default LoginPage;
